import { keycloakInit } from "./plugins";
import initQiankun from "./mfe";
import globalState from "../../globalState";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createStore } from "./store";
import { inject, excutePlugins } from "@/utils";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import { axiosCustomInstance, axiosCustomAuth } from "../../main-app/src/shared/index";
import axios from "axios";
import VueAxios from "vue-axios";

const bootstrap = async () => {
  let keycloak = await keycloakInit();
  const vue3app = createApp(App);
  const pjson = require('../package.json');
  const version = `${pjson.name}@${pjson.version}`;

  let activaVersion = `%c [@ctivAMB - version] -> ${version}`;
  let consoleSignatureStyle = [
    'font - size: 13px',
    'font - family: monospace',
    'background: #f44336 linear-gradient(to bottom left, #fa675c 0, #db281a 75%)',
    'color: white',
    'text-align: center',
    'padding: 10px 15px',
    'width: 100%',
    'border: 1px dashed;'
  ].join(';')

  try {
    const mainAppScope = {
      context: vue3app,
      createStore,
      inject
    };

    await excutePlugins(initQiankun, mainAppScope, { globalState: globalState, keycloak: keycloak });

    let axiosInstance = axiosCustomInstance(axios, {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    });

    let customAuth = axiosCustomAuth(axiosInstance, keycloak.idToken);

    vue3app
      .use(Quasar, quasarUserOptions)
      .use(createStore(vue3app))
      .use(router)
      .use(VueAxios, customAuth)
      // .config.globalProperties.$axios = { ...customAuth }
        .mount("#app");

    // eslint-disable-next-line no-console
    console.log(activaVersion, consoleSignatureStyle);

  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}

// const mount = async () => {
//   let axiosInstance = axiosCustomInstance(axios, {
//     Accept: 'application/json',
//     'Content-Type': 'application/json',
//   });

//   let customAuth = axiosCustomAuth(axiosInstance, 'TOKEN KEYCLOAK 123456789');

//   bootstrap(customAuth);

// }

bootstrap();


